// @flow

import React from 'react';
import styled, { keyframes, withTheme } from 'styled-components';

const spinKeyframes = keyframes`
  0% { transform: rotate(-80deg) }
  100% { transform: rotate(280deg) }
`;

const SpinnerSvg = styled.svg`
  animation: ${spinKeyframes} 1s infinite ease-out;
`;

const Spinner = withTheme(({ height, width, theme }) => (
  <SpinnerSvg
    width={width || '2rem'}
    height={height || '2rem'}
    viewBox="0 0 60 60"
  >
    <g>
      <path
        d="M52.948629,49.1042199 C47.4743174,55.6873285 39.2225198,59.8783258 29.9919541,59.8783258 C13.5096181,59.8783258 0.148044843,46.5155012 0.148044843,30.0316217 C0.148044843,14.46238 12.0679735,1.67744753 27.2788714,0.306591722 L27.2788714,4.85320673 C14.5678881,6.21807961 4.66984927,16.9807376 4.66984927,30.0554229 C4.66984927,44.0548899 16.0175969,55.4037003 30.0157531,55.4037003 C37.7237108,55.4037003 44.6280503,51.9626793 49.276687,46.5328577 L52.948629,49.1042199 L52.948629,49.1042199 Z"
        fill={theme.textColor}
      />
      <path
        d="M56.0260168,44.6344868 C58.4521532,40.317622 59.8358633,35.3362283 59.8358633,30.0316217 C59.8358633,14.46238 47.9159347,1.67744753 32.7050367,0.306591722 L32.7050367,4.84814111 C45.4388998,6.1912225 55.3616568,16.9644221 55.3616568,30.0554229 C55.3616568,34.3976398 54.2699408,38.4848489 52.346038,42.0574966 L56.0260168,44.6344868 L56.0260168,44.6344868 Z"
        fill={theme.actionColor}
      />
    </g>
  </SpinnerSvg>
));

Spinner.displayName = 'Spinner';

export default Spinner;
